export { default } from './LlistatPrevisioMunicipis';
